import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createPortal } from 'react-dom';
import Panel from '@/components/Panel';
import { getPanelMaxHeight, getPanelMaxWidth, getPanelWidth } from '../../../../../services/helper/panelSizeHelper';
import { PowerSINetManagerFn } from '../../../../../services/Sierra';
import { Checkbox, Radio, Tabs } from 'antd';
import EditableTable from '../../../../../components/EditableTable';
import { powerSINetManagerErrorCheck } from '../../../../../services/Sierra/errorCheck';
import { saveVerificationContentToServer, updateSierraInfo } from '../../../store/sierra/action';
import designConstructor from '../../../../../services/helper/designConstructor';
import { PRE_LAYOUT } from '../../../../../constants/designVendor';
import _ from 'lodash';
import './index.css';

const columns = [{
  key: "name",
  title: "Nets",
  dataIndex: "name",
  width: "44%"
},
{
  key: "coupling",
  title: "% Coupling",
  dataIndex: "coupling",
  width: "28%"
},
{
  key: "riseTime",
  title: "Rise Time (ps)",
  dataIndex: "riseTime",
  width: "28%"
}]
class SettingPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maxHeight: 600,
      maxWidth: 1000,
      activeKey: "",
      netsManagerList: [],
      applyAll: false,
      applySameType: false,
      panelHeight: 600
    }
    this.dialogRoot = document.getElementById('root');

    columns[1].onCell = (record) => {
      return {
        record,
        edit: true,
        dataIndex: 'coupling',
        handleSave: (_record) => this.valueUpdate(_record, 'coupling')
      }
    }

    columns[2].onCell = (record) => {
      const riseTime = record.riseTime ? record.riseTime.replace("ps", "") : '';
      return {
        record: { ...record, riseTime },
        edit: true,
        dataIndex: 'riseTime',
        handleSave: (_record) => this.valueUpdate(_record, 'riseTime')
      }
    }

    columns[2].render = (text, record) => {
      const value = record.riseTime ? record.riseTime.replace("ps", "") : '';
      return <span>{value}</span>
    }
  }

  valueUpdate = (record, type) => {
    const { name } = record;

    const error = powerSINetManagerErrorCheck(record[type], type);
    const value = type === "riseTime" ? `${record[type]}ps` : record[type];
    if (error) {
      this.setState({
        errorMsg: error
      })
      setTimeout(() => {
        this.setState({
          errorMsg: null
        })
      }, 3000)
      return;
    }
    const { netsManagerList, activeKey, applyAll, applySameType } = this.state;
    const _Interfaces = [...this.props.Interfaces];
    let _netsManagerList = [...netsManagerList];
    const index = _netsManagerList.length > 1 ? _netsManagerList.findIndex(item => item.pcbId === activeKey) : 0;
    if (index < 0) {
      return;
    }
    const pcbId = _netsManagerList[index].pcbId;
    const interIndex = _Interfaces.findIndex(item => item.pcbId === pcbId);
    const signalNets = applySameType ? _Interfaces[interIndex].content.signals.map(item => item.nets).flat(2) : [];
    const powerNets = applySameType ? _Interfaces[interIndex].content.powerNets.map(item => item.name) : [];
    const netList = _netsManagerList[index].netList || [];
    const netIndex = netList.findIndex(netItem => netItem.name === name);
    if (netIndex < 0) {
      return;
    }

    netList[netIndex][type] = value;
    //apply all
    if (applyAll || applySameType) {

      const isSignal = signalNets.includes(record.name),
        isPower = powerNets.includes(record.name);

      netList.forEach(item => {
        if (applySameType && !applyAll) {
          if ((isSignal && signalNets.includes(item.name))
            || (isPower && powerNets.includes(item.name))) {
            item[type] = value;
          }
        }
        if (applyAll) {
          item[type] = value;
        }
      })
    }
    _netsManagerList[index].netList = netList;

    if (interIndex > -1) {
      _Interfaces[interIndex].content.netList = JSON.parse(JSON.stringify(netList));
    }
    this.setState({
      netsManagerList: _netsManagerList
    })
    this.props._updateSierraInfo({ Interfaces: _Interfaces });
  }

  componentDidMount = () => {
    window.addEventListener('resize', this.resize);
    this.resize();
    this.initData()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  resize = () => {
    const offset = this.dialogRoot.getBoundingClientRect();
    this.setState({
      maxHeight: getPanelMaxHeight(offset, 800) - 80,
      maxWidth: getPanelMaxWidth(offset, 600)
    })
  }

  componentDidUpdate(prevProps) {
    const {/*  signals, powerNets,  */Interfaces } = this.props;
    /*   const signalNets = signals.map(item => item.nets.map(net => `${net.name}::${item.pcbId}`)).flat(2)
      const newPowerNets = powerNets.map(item => `${item.name}::${item.pcbId}`);
   */
    const filterInterfacePSI = (Interfaces || []).filter(item => designConstructor.getDesignVendor(item.pcbId) !== PRE_LAYOUT && item.content && item.content.channel && item.content.channel.type === "PowerSI").map(item => item.pcbId);
    const filterPrevInterfacePSI = (this.state.netsManagerList || []).map(item => item.pcbId);
    if (!_.isEqual(filterInterfacePSI, filterPrevInterfacePSI)) {
      this.initData();
    }
  }

  initData = () => {
    const { Interfaces } = this.props;
    let data = [];
    let _Interfaces = [...Interfaces];

    for (let info of _Interfaces || []) {
      if (info.content && info.content.channel && info.content.channel.type === "PowerSI") {
        const signalList = info.content.signals.map(item => item.nets).flat(2);
        const powerList = info.content.powerNets.map(item => item.name);

        const netList = signalList.concat(powerList).map(net => {
          const findItem = (info.content.netList || []).find(netItem => netItem.name === net) || {};
          return new PowerSINetManagerFn({ name: net, riseTime: findItem.riseTime, coupling: findItem.coupling })
        });
        info.content.netList = netList;
        data.push({
          pcb: info.pcb,
          pcbId: info.pcbId,
          netList: JSON.parse(JSON.stringify(netList))
        });
      }
    }
    this.setState({
      netsManagerList: data,
      activeKey: data[0] ? data[0].pcbId : ""
    })
    this.props._updateSierraInfo({ Interfaces: _Interfaces })
  }

  getTabItems = () => {
    const { netsManagerList } = this.state;
    return netsManagerList.map(item => ({
      label: item.pcb,
      key: item.pcbId,
      children: this.getNetListTable(item.netList)
    }));
  }

  handleTabChange = (key) => {
    this.setState({
      activeKey: key
    })
  }

  updateApply = (e, type) => {
    this.setState({
      [type]: e.target.checked
    })
  }

  getPanelHeight = (height) => {
    this.setState({ panelHeight: height })
  }

  closeModal = () => {
    const { Interfaces } = this.props;
    this.props._saveVerificationContentToServer({ pcbs: Interfaces.map(item => item.pcbId) });
    this.props.updateSettingVisible(false);
  }
  render() {
    const { maxHeight, maxWidth, activeKey, netsManagerList, errorMsg, applyAll, applySameType } = this.state;
    const { Interfaces } = this.props;
    const content = (
      <Panel
        className='sierra-setup-powersi-nets-manager-panel sierra-panel'
        title="PowerSI Net Manager"
        onCancel={this.closeModal}
        zIndex={2000}
        width={getPanelWidth(maxWidth, { defaultWidth: 600 })}
        maxHeight={maxHeight}
        position='panel-center-top'
        draggable
        minHeight={300}
        minWidth={400}
        maxWidth={maxWidth}
        getPanelHeight={this.getPanelHeight}
      >
        <div className='sierra-setup-powersi-nets-manager-content'>
          {Interfaces.length > 1 ? <Tabs
            activeKey={activeKey}
            items={this.getTabItems()}
            onChange={this.handleTabChange}
          /> : this.getNetListTable(netsManagerList[0] ? netsManagerList[0].netList : [])}
          {errorMsg && <div className='aurora-model-name-error-msg'>{errorMsg}</div>}
          <div className='sierra-apply-powersi-net-content'>
            <Checkbox
              checked={applyAll}
              className='sierra-apply-powersi-net-checkbox'
              onClick={(e) => this.updateApply(e, "applyAll")}
            >
              Apply setup to all nets</Checkbox>
            <Checkbox
              checked={applySameType}
              className='sierra-apply-powersi-net-checkbox'
              onClick={(e) => this.updateApply(e, "applySameType")}
            >
              Apply setup to all nets of the same type (Signal / Pwr.GND)</Checkbox>
          </div>

        </div>

      </Panel>
    )
    return createPortal(content, this.dialogRoot);
  }

  getNetListTable = (netList) => {
    const { panelHeight } = this.state;
    const { Interfaces } = this.props;
    const height = netList.length * 40;
    const scrollHeight = Interfaces.length > 1 ? panelHeight - 210 : panelHeight - 170;
    return <div>
      <EditableTable
        className="sierra-powersi-nets-manager-table"
        columns={columns}
        rowKey={(record) => record.name}
        dataSource={netList || []}
        scroll={height > scrollHeight ? { y: scrollHeight } : {}}
      />
    </div>
  }
}
const mapState = (state) => {
  const { SierraReducer: { sierra: { sierraInfo } } } = state;
  const { Interfaces, info } = sierraInfo || {};
  return {
    Interfaces,
    signals: info.signals || [],
    powerNets: info.powerNets || [],
  }
}

const mapDispatch = (dispatch) => ({
  _updateSierraInfo(info) {
    dispatch(updateSierraInfo(info));
  },
  _saveVerificationContentToServer({ pcbs }) {
    dispatch(saveVerificationContentToServer({ pcbs }))
  }
})

export default connect(mapState, mapDispatch)(SettingPanel);
